import { memo } from "react";
import InputText from "../../staff/InputText";
import { usePersonForm } from "./personForm/PersonFormContext";
import {
  PERSON_SOCIAL_FIELD_DEFS,
  getSocialUrl,
  socialNetworkErrorKey,
} from "./personForm/socialNetworks";

const SocialMediaComponent = () => {
  const {
    form,
    updateSocialNetworkUrl,
    touchField,
    getFieldError,
    shouldShowError,
  } = usePersonForm();

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-6 gap-5">
      {PERSON_SOCIAL_FIELD_DEFS.map(({ name, title, placeholder }) => {
        const errKey = socialNetworkErrorKey(name);
        const fieldId = `wsg-social-url-${name.replace(/\s+/g, "-")}`;
        return (
          <InputText
            key={name}
            id={fieldId}
            name={fieldId}
            title={title}
            placeholder={placeholder}
            autoComplete="off"
            spellCheck={false}
            lpIgnore
            value={getSocialUrl(form.socialNetworks, name)}
            onChange={(v) => updateSocialNetworkUrl(name, v)}
            onBlur={() => touchField(errKey)}
            error={
              shouldShowError(errKey) && Boolean(getFieldError(errKey))
            }
            errorMessage={getFieldError(errKey)}
          />
        );
      })}
    </div>
  );
};

const SocialMedia = memo(SocialMediaComponent);
export default SocialMedia;
